import { defineStore } from "pinia";
import { User, UserAdapter } from "@/core/models/user";
import { setSentryContext } from "@/core/services/sentry.service";
import { ref } from "vue";

const LOCAL_STORAGE_KEY = "cx-user";

const useUserStore = defineStore("user", () => {
  const storedUser = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  const currentUser = ref<User | null>(storedUser ? UserAdapter.adaptAuthenticatedUser(JSON.parse(storedUser)) : null);

  const resetUser = () => {
    currentUser.value = null;
    window.localStorage.removeItem(LOCAL_STORAGE_KEY);
    setSentryContext(null);
  };

  const setUser = (user: User) => {
    currentUser.value = user;
    window.localStorage.setItem(LOCAL_STORAGE_KEY, UserAdapter.serializeAuthenticatedUser(user));
    setSentryContext(user);
  };

  return {
    currentUser,

    resetUser,
    setUser,
  };
});

export default useUserStore;
